import React, { useState, useEffect } from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import Toggle from 'react-toggle';

import 'react-toggle/style.css';
import SelectComp from './Select';

import { Row, Col, Container } from 'react-bootstrap';

function SpreadFindModal({ onCloseFunc, fullData, onSearchMetod }) {
  const { i18n, t } = useTranslation();
  const [pageOrder, setPageOrder] = useState(1);
  const [dateCriteria, setDateCriteria] = useState(false);
  const [pageCriteria, setPageCriteria] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dates, setDates] = useState([]);
  const [pages, setPages] = useState([]);

  const getUniqueLastModifiedDates = arr => {
    let uniqueDates = new Set();

    arr.forEach(obj => {
      if (obj.firstContent && obj.firstContent.lastModifiedDate) {
        uniqueDates.add(obj.firstContent.lastModifiedDate);
      }
    });

    return Array.from(uniqueDates);
  };

  const createNumbersArray = n => {
    const numberArray = [];
    for (let i = 1; i <= n; i++) {
      numberArray.push(i);
    }
    return numberArray;
  };

  useEffect(() => {
    setDates(getUniqueLastModifiedDates(fullData));
    setPages(createNumbersArray(fullData.length * 2));
  }, []);

  function handlePageChange(event) {
    setPageOrder(Number(event.target.value));
    setSelectedDate(null);
  }

  function handleDateChange(event) {
    event.preventDefault();
    event.stopPropagation();
    const selectedIndex = event.target.selectedIndex;
    const date = selectedIndex === 0 ? null : event.target.value;
    setSelectedDate(date);
    setPageOrder(1);
  }

  function handleCriteriaChange(event) {
    setDateCriteria(event.target.checked);
    setPageCriteria(!event.target.checked);
  }

  function onClose(event) {
    event.preventDefault();
    event.stopPropagation();
    onCloseFunc && onCloseFunc(event);
  }

  function onSave() {
    if (pageCriteria) {
      onSearchMetod(pageOrder, 'page-order');
      onCloseFunc && onCloseFunc(event);
    }
    if (dateCriteria) {
      onSearchMetod(selectedDate, 'date');
      onCloseFunc && onCloseFunc(event);
    }
  }

  return (
    <>
      <div className="find-modal" id="modal">
        <button type="button" onClick={onClose} className="btn-close" aria-label="Close"></button>
        <h2>{t('chooseFindOptions')}</h2>
        <Container>
          <Row className="content">
            <Row className="criteria-row">
              <Col className={pageCriteria ? 'find-sub-title active' : 'find-sub-title'} xs={6}>
                {t('pageCriteria')}
              </Col>
              <Col className="toggle-input" xs={3}>
                <Toggle defaultChecked={false} icons={false} onChange={handleCriteriaChange} />
              </Col>
              <Col className={dateCriteria ? 'find-sub-title active' : 'find-sub-title'} xs={3}>
                {t('dateCriteria')}
              </Col>
            </Row>
            <hr />
            {pageCriteria && (
              <Col className="criteria" xs={12}>
                <SelectComp
                  nameItem="page"
                  valueItem={pageOrder}
                  arrayItems={pages}
                  onChangeFunc={handlePageChange}
                  labelName={'pageCriteriaLabel'}
                />
              </Col>
            )}
            {dateCriteria && (
              <Col className="criteria" xs={12}>
                {dates.length > 0 && (
                  <SelectComp
                    nameItem="date"
                    valueItem={selectedDate}
                    arrayItems={dates}
                    onChangeFunc={handleDateChange}
                    labelName={'dateCriteriaLabel'}
                  />
                )}
              </Col>
            )}
          </Row>
        </Container>

        <div className="actions">
          <button className="actions-btn" onClick={onSave}>
            <span>{t('find')}</span>
          </button>
        </div>
      </div>
      <div className="modal-backdrop"></div>
    </>
  );
}

export default SpreadFindModal;
